import { atom } from 'recoil';
import i18n from '../i18n';

export const langAtom = atom({
  key: 'langAtom',
  default: i18n.language || 'it', // Usa la lingua corrente di i18n come default
  effects: [
    ({ setSelf }) => {
      // Ascolta i cambiamenti di lingua da i18next (rilevamento automatico)
      const handleLanguageChange = (lng) => {
        setSelf(lng);
      };

      i18n.on('languageChanged', handleLanguageChange);

      // Cleanup
      return () => {
        i18n.off('languageChanged', handleLanguageChange);
      };
    },
  ],
});

// Funzione helper per cambiare lingua manualmente
export const changeLanguage = (newLang) => {
  i18n.changeLanguage(newLang);
  // L'atom verrà aggiornato automaticamente dall'evento languageChanged
};